var map = {
	"./dice-0.png": 2191,
	"./dice-1.png": 3505,
	"./dice-2.png": 7044,
	"./dice-3.png": 8926,
	"./dice-4.png": 8004,
	"./dice-5.png": 1311,
	"./dice-6.png": 7045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1468;